var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProjectIndexArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 14,
    viewBox: "0 0 29 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.875 7L22.131.256 20.518 1.87l3.989 3.989H.797v2.282h23.71l-3.99 3.99 1.614 1.613L28.875 7z",
    fill: "#353844"
  })));
}
export default __webpack_public_path__ + "media/images/ProjectIndexArrow-369d791a.svg";
export { SvgProjectIndexArrow as ReactComponent };